import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'
import { useNavigate } from 'react-router-dom'
import { FaEdit, FaToggleOff, FaToggleOn, FaTrashAlt, FaUserPlus } from 'react-icons/fa'

export default function AllNewAdmissions() {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [newAdmission, setNewAdmission] = useState([])
  const [selectedAdmission, setSelectedAdmission] = useState(null)

  const fetchNewAdmissions = async() => {
    try{
        const res = await axios.get(`${config.baseurl}get_admin_new_admissions/`,{
            headers:{
                'Content-Type':'application/json',
                'Authorization':`Token ${token}`
            }
        })
        console.log('New Admission Res:', res.data)

        if(res.status === 200){
            setNewAdmission(res.data.data)
        }else{
            toast.error('Failed to fetch staffs')
        }
    }catch(error){
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Staff'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchNewAdmissions()
  },[token])
  console.log('New Admission:', newAdmission)

  const handleDelete = async(id) => {
    console.log('New Admission Id:', id)

    if(!id){
      toast.error('Invalid New Admission id')
      return
    }

    try{
      const res = await axios.delete(`${config.baseurl}delete_new_admission/${id}/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('NewAdmission Deleted Successfully')
      await fetchNewAdmissions()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to delete New Admision'

      toast.error(message)
    }
  }

  const handleStatus = async(id) => {
    console.log('New Admission Id:', id)

    if(!id){
      toast.error('Invalid New Admission id')
      return
    }

    try{
      const res = await axios.put(`${config.baseurl}activate_new_admission/${id}/`, {}, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('New Admission Status Changed Successfully')
      await fetchNewAdmissions()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to Activate new admission'

      toast.error(message)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <AdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL New Admissions
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all registered New Admissions in one place.
        </p>
      </div>

      <div className='max-w-7xl mx-auto px-6 pb-10'>
        <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full table-auto'>
              <thead>
                <tr className='text-center border-b border-slate-300'>
                  <th className='px-3 py-2 whitespace-nowrap'>No</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Name</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Age</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Date of Birth</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Gender</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Category</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Status</th>
                </tr>
              </thead>

              <tbody>
                {newAdmission.length > 0 ? (
                  newAdmission.map((item, index) => (
                    <tr
                      key={item.id}
                      className='text-center border-b border-b-slate-300 cursor-pointer'
                      onClick={(e) => {
                        if(e.target.closest('button')){
                          return
                        }

                        navigate(`/admin/new_admission_overview/${item.id}`,{state:item})
                      }}
                    >
                      <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.first_name} {item.last_name}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.age}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.dob}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.gender}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.category}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.is_active ? 'Active' : 'Inactive'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className='text-center py-6'
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
